import { candidates } from "routes/SnippetsPage/candidates";

/**
 * 共通化候補（まだコンポーネント化されていないパターン）の一覧。
 * @return {JSX.Element} セクション
 */
export const CandidateSection = (): JSX.Element => {
  return (
    <section id="section-candidate" className="scroll-mt-24 space-y-4">
      <header>
        <h2 className="text-xl font-bold">共通化候補</h2>
        <p className="text-sm text-base-content/60">
          /components にまだ存在しないが、複数ページで繰り返し使われている UI
          パターン。新規コンポーネント化のバックログとして扱う。
        </p>
      </header>

      <div className="grid gap-4">
        {candidates.map(candidate => (
          <article
            key={candidate.id}
            id={candidate.id}
            className="border border-dashed border-base-300 rounded-lg bg-base-100 p-4 space-y-3"
          >
            <header className="flex items-start justify-between gap-4 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-mono text-xs text-base-content/60">
                    {candidate.id}
                  </span>
                  <h3 className="text-base font-bold">{candidate.title}</h3>
                  <span className="badge badge-sm badge-outline">
                    {candidate.pattern}
                  </span>
                </div>
                <p className="text-xs text-base-content/60 mt-1">
                  {candidate.description}
                </p>
                <p className="text-[10px] text-base-content/40 mt-1">
                  想定 import:
                  <code className="ml-1 px-1 bg-base-200 rounded font-mono">
                    {candidate.suggestedComponent}
                  </code>
                </p>
              </div>
            </header>

            <pre className="bg-base-200/60 rounded p-3 text-xs overflow-x-auto whitespace-pre-wrap">
              {candidate.example}
            </pre>

            <details className="text-xs text-base-content/70">
              <summary className="cursor-pointer">
                代表的な参照箇所 ({candidate.foundIn.length})
              </summary>
              <ul className="mt-2 space-y-0.5 font-mono">
                {candidate.foundIn.map(path => (
                  <li key={path}>{path}</li>
                ))}
              </ul>
            </details>
          </article>
        ))}
      </div>
    </section>
  );
};
